module.exports = __webpack_public_path__ + "img/video-01.864cf135.png";